var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWalletSelectIndicator = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30468 14.4482C8.03232 14.4482 7.75711 14.3441 7.54892 14.1345L4.1637 10.7507C3.74589 10.3329 3.74589 9.65696 4.1637 9.23915C4.5815 8.82134 5.25741 8.82134 5.67521 9.23915L8.30468 11.8658L14.3165 5.85535C14.7343 5.43754 15.4102 5.43754 15.828 5.85535C16.2459 6.27315 16.2459 6.94906 15.828 7.36686L9.06044 14.1345C8.85225 14.3441 8.57847 14.4482 8.30468 14.4482Z",
    fill: "#5AA7F8"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWalletSelectIndicator, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wallet-select-indicator.70a8c342.svg";
export { ForwardRef as ReactComponent };